import { createFileRoute, redirect } from '@tanstack/react-router';

import { UserRoles } from '~entities/users/model/types';

import { AnnouncementsListPage } from '~features/announcements';

import { checkMinRoleValue } from '~shared/utils/role-guard';

export const Route = createFileRoute('/_auth/_layout/announcements/')({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.ADMIN);
    if (!hasAccess) {
      return redirect({ to: '/dashboard' });
    }
  },
  component: AnnouncementsListPage,
});
